import { connect } from 'react-redux';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import SummaryComponent from '../../../components/orders-drawer/sections/summary';
import Global from '../../../store/global-selectors';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { OrderDrawerSection } from '../../../enums/order-drawer-section';

const sectionId = OrderDrawerSection.summary;

const mapStatesToProps = (state, ownProps) => {
  const { salesOrderId, salesOrderIds, currentFulfillmentPlanId } = ownProps;
  const salesOrder = Global.selectEntitiesSalesOrderById(state, { salesOrderId }) || emptyObject;
  const salesOrders = Global.selectEntitiesSalesOrdersByIds(state, { salesOrderIds }) || emptyArray;
  const fulfillmentPlan =
    Global.selectEntitiesFulfillmentPlanById(state, {
      fulfillmentPlanId: currentFulfillmentPlanId,
    }) || emptyObject;

  const { orderDateTime, shipByDateTime, amountSummary, discounts = emptyArray, fulfillmentPlanIds = emptyArray } = salesOrder;

  const rawPaidDate = fulfillmentPlan.fulfillmentPlanDates?.paidDate;
  const holdUntilDateTime = fulfillmentPlan.fulfillmentPlanDates?.holdUntilDate;
  const orderGridStatus = fulfillmentPlan.orderGridStatus;

  return {
    amountSummary,
    discounts,
    fulfillmentPlanIds,
    holdUntilDateTime,
    orderDateTime,
    orderGridStatus,
    paidDateTime: rawPaidDate,
    salesOrders,
    shipByDateTime,
    premiumPrograms: fulfillmentPlan.premiumPrograms || emptyArray,
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const SummarySectionContainer = connect(mapStatesToProps, mapDispatchToProps);
export const Summary = SummarySectionContainer(SummaryComponent);
